import { useEffect } from 'react'
import { TableInstance, UseColumnOrderState } from 'react-table'
import { ColumnState } from 'core/table/interfaces/ColumnState'

interface UsePinnedTableColumnOptions {
  table: TableInstance<any>
  columnId: string
  columnState?: ColumnState[]
  columnStateLoading?: boolean
  columnIds: string[]
}

export default function usePinnedTableColumn({
  table,
  columnId,
  columnState,
  columnStateLoading,
  columnIds,
}: UsePinnedTableColumnOptions) {
  useEffect(() => {
    if (columnStateLoading) {
      return
    }

    const enforcePinnedColumn = () => {
      const { columnOrder, hiddenColumns = [] } = table.state as typeof table.state & UseColumnOrderState<any>
      const currentOrder = columnOrder?.length ? columnOrder : columnIds
      const orderWithoutPinnedColumn = currentOrder.filter(id => id !== columnId)

      // @ts-ignore useColumnOrder adds setColumnOrder at runtime
      table.setColumnOrder([...orderWithoutPinnedColumn, columnId])

      const nextHiddenColumns = hiddenColumns.filter(id => id !== columnId)
      if (nextHiddenColumns.length !== hiddenColumns.length) {
        table.setHiddenColumns(nextHiddenColumns)
      }
    }

    const timeoutId = window.setTimeout(enforcePinnedColumn, 0)
    return () => window.clearTimeout(timeoutId)
  }, [columnId, columnIds, columnState, columnStateLoading, table])
}
